import type { FaireProductEntity } from "../../entity_types/product";

export const p_fbkjjdeybb: FaireProductEntity = {
  token: "p_fbkjjdeybb",
  type: "product",
  name: "Sparkling Rhinestones 14K Gold Plated Enamel Bee Ear Studs",
  brandToken: "b_nex9pcmkzj",
  brandName: "Mio Queena",
  imageUrl:
    "https://cdn.faire.com/fastly/40b81174662ea8faf5045d410968633b77875d79540036ead5f14595949c79db.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d305a3925d6cc3a56d77660a7aad245f1397b8154d155c2c7005140222c590c3.jpeg",
    "https://cdn.faire.com/fastly/ca8780106ee5ee927ab24e4626ff32b5f484419bc2cbfab2da96909a284d0896.jpeg",
    "https://cdn.faire.com/fastly/751dc2bb735e1f3b4d0571f63cc924eb9feabab1688fc6f334925fb0b9d54326.jpeg",
  ],
  priceDollars: 6.83,
  description:
    "Type: Earrings\nMaterial : Copper , Enamel，Rhinestone，14K Gold Plated\nSize :17mm*15mm\n★Made of high quality material, Nickel-free / Lead-free, Harmless to Human Body.\n★Perfect jewelry gifts ",
  tags: [],
  msrpDollars: 16.39,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:06.603Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
